import { render, staticRenderFns } from "./PowerStationDetail.vue?vue&type=template&id=4587c8c2&scoped=true&"
import script from "./PowerStationDetail.vue?vue&type=script&lang=js&"
export * from "./PowerStationDetail.vue?vue&type=script&lang=js&"
import style0 from "./PowerStationDetail.vue?vue&type=style&index=0&id=4587c8c2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4587c8c2",
  null
  
)

export default component.exports